import { useParams } from "react-router-dom";
import { PlantFormTabs } from "./PlantFormTabs";
import Plant from "../Plant";
import { useUpdatePlant } from "../Hooks/useUpdatePlant";
import { useFetchPlant } from "../Hooks/useFetchPlant";
import { useDeletePlant } from "../Hooks/useDeletePlant";
import { nameOf } from "../../Utils/nameOf";
import { plantDefaultValues } from "./PlantDefaultValues";

export const EditPlant = () => {
  const { plantId } = useParams();

  // TODO - is there a cleaner way?
  const plantIdAsNumber = Number(plantId);

  const { data: plant } = useFetchPlant(plantIdAsNumber);

  // TODO - Remove PlantId here
  // TODO - Use API return value for user notification
  const { mutate: updatePlant } = useUpdatePlant(plantId);
  const { mutate: deletePlant } = useDeletePlant(plantId);

  const disabledFields: Array<string> = [
    nameOf<Plant>("Gsdb"),
    nameOf<Plant>("CountryIsoCode"),
    nameOf<Plant>("MapAndGuideLatitude"),
    nameOf<Plant>("MapAndGuideLongitude"),
  ];

  return (
    <PlantFormTabs
      title="Edit Plant"
      plant={plant ?? plantDefaultValues}
      onSave={(it: Plant) => updatePlant(it)}
      onDelete={() => deletePlant(plantIdAsNumber)}
      disabledFields={disabledFields}
    />
  );
};
